import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {mediaData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{mediaData.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaData.items.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-300">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-sm"></i>
                  </div>
                  <span className="text-xs text-white/90 bg-black/40 px-2 py-0.5 rounded-full">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}